import * as React from 'react'
import { connect } from 'react-redux'
import { spacerAlignItems, Spacer, Spacing } from 'DVWebNodeUI'
import { PlaybackMessaging } from '../../components/playbackMessaging/playbackMessaging'
import { Refund } from '../../components/refund/refund'
import { TextBlockNotification } from '../../components/notificationAction/notificationAction'
import { Trailer } from '../../components/playback/trailer'
import { Watchlist } from '../../components/watchlist/watchlist'
import { DisneyAction } from '../../components/disneyAction/disneyAction'
import { RedeemAndPromoLink } from '../../components/redeemAndPromoLink/redeemAndPromoLink'
import { SecondaryOfferMessage } from '../../components/secondaryOfferMesssage/secondaryOfferMessage'
import { Acquisition } from '../../components/acquisition/acquisition'
import { AtfMorePurchaseOptions } from '../../components/morePurchaseOptions/atfMorePurchaseOptions'
import { MultiplePlayback } from '../../components/playback/multiplePlayback'
import { TvodButtonScope } from '../../components/acquisition/tvodButton'
import { AgeVerification } from '../../components/ageVerification/ageVerification'
import { PurchaseOverlay } from '../../components/actionBox/disableOverlay'
import { IDetailPageState } from '../../reducers'
import { ActionBoxState } from '../../reducers/actionBox'
import {
  playbackMessagingComponentSelector,
  refundComponentSelector,
  notificationActionsTextBlockMessagesSelector,
  trailerComponentSelector,
  purchaseComponentSelector,
  disneyComponentSelector,
  mwtwComponentSelector,
  secondaryOfferMessageComponentSelector,
  ageVerificationSelector,
  multiplePlaybackComponentSelector,
  downloadComponentSelector
} from '../../selectors/component/actionBoxComponentSelectors'
import { purchaseSelector } from '../../selectors/purchase'
import * as st from '../../components/actionBox/actionBox.module.scss'
import * as cn from 'classnames'
import { AdjustHeightForContent } from '../../utils/AdjustHeightForContent'
import { PurchaseFailedModal } from '../../components/actionBox/purchaseFailedModal'
import { DownloadAction, DownloadStatus, DownloadButtonWithLabel } from '@shared'

type ActionBoxComponentProps = ReturnType<typeof mapStateToProps>

export const ActionBoxComponent = ({
  actionBox,
  playbackMessaging,
  refund,
  notificationBox,
  playbackActions,
  downloadAction,
  trailerAction,
  purchaseAction,
  disneyAction,
  moreWaysToWatch,
  secondaryOfferMessage,
  ageVerification,
  purchaseDetails
}: ActionBoxComponentProps) => {

  const isPurchasingMfa = Boolean(purchaseDetails)
  const isPurchasingAui = Boolean(actionBox && actionBox.main && actionBox.main.state === ActionBoxState.purchasing)

  const purchasingText =
    (isPurchasingMfa &&
      purchaseDetails!.details &&
      purchaseDetails!.details!.offer.purchaseData.text) ||
    (isPurchasingAui && actionBox.main.purchasingText) ||
    ''
  const isPurchasing = isPurchasingMfa || isPurchasingAui
  return (
    <div className={st.actionBox}>
      <div className={cn({ [st.isPurchasing]: isPurchasing }, st.wrapper)}>
        <AdjustHeightForContent className={'dv-node-dp-action-box'}>
          <PlaybackMessaging {...playbackMessaging} />
          <AgeVerification {...ageVerification} />
          {refund && <Refund {...refund} />}
          <Spacer alignItems={spacerAlignItems.top}>
            <TextBlockNotification {...notificationBox} />
            {playbackActions && <MultiplePlayback {...playbackActions} />}
            <Spacer alignItems={spacerAlignItems.top} className="avu-full-width-phablet">
              {trailerAction && <Trailer {...trailerAction} />}
              <Acquisition {...purchaseAction} tvodButtonScope={TvodButtonScope.ACTION_BOX} forceDoubleHeight={true} />
              {moreWaysToWatch && <AtfMorePurchaseOptions {...moreWaysToWatch} />}
              <Watchlist isHover={false} />
              <DisneyAction {...disneyAction} />
              {downloadAction &&
                (global.__NATIVEAPP__ ? (
                  <DownloadAction downloadInfo={downloadAction} withLabel />
                ) : (
                  <DownloadButtonWithLabel {...downloadAction} status={DownloadStatus.IDLE} />
                ))}
            </Spacer>
          </Spacer>
          <div className={Spacing.small}>
            <RedeemAndPromoLink placement={'ActionBox'} />
            <SecondaryOfferMessage {...secondaryOfferMessage} />
          </div>
        </AdjustHeightForContent>
      </div>
      {isPurchasing && <PurchaseOverlay purchasingText={purchasingText} />}
      <PurchaseFailedModal />
    </div>
  )
}


const mapStateToProps = (state: IDetailPageState) => ({
  actionBox: state.actionBox,
  playbackMessaging: playbackMessagingComponentSelector(state),
  refund: refundComponentSelector(state),
  notificationBox: notificationActionsTextBlockMessagesSelector(state),
  playbackActions: multiplePlaybackComponentSelector(state),
  downloadAction: downloadComponentSelector(state),
  trailerAction: trailerComponentSelector(state),
  purchaseAction: purchaseComponentSelector(state),
  disneyAction: disneyComponentSelector(state),
  moreWaysToWatch: mwtwComponentSelector(state),
  secondaryOfferMessage: secondaryOfferMessageComponentSelector(state),
  ageVerification: ageVerificationSelector(state),
  purchaseDetails: purchaseSelector(state)
})

export const ActionBox = connect(mapStateToProps)(ActionBoxComponent)
